import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ArrowsClockwise, Warning} from '../../icons';
import {attentionText} from './platformsText';

const NS = 'agency_v2.platforms';

/**
 * El aviso de arriba (D6): los accesos que necesitan atención, cada uno con su «Reconectar» (o, en una
 * conexión de Mercado Ads que hizo el cliente, «Enviar un link nuevo al vendedor»). Sin ninguno, no se
 * dibuja.
 */
export function AttentionNotice({items, onReconnect, onSendLink = null}) {
    const {t, i18n} = useTranslation();
    const [busy, setBusy] = useState(null);
    if (!items.length) return null;

    const reconnect = (item) => () => {
        const key = `${item.channel}-${item.credential.id}`;
        if (busy) return;
        setBusy(key);
        Promise.resolve(onReconnect(item.channel, item.credential)).then((result) => {
            // Si se fue a la plataforma, el botón queda ocupado hasta que la página cambia.
            if (!result || !result.ok || result.stays) setBusy(null);
        });
    };

    return (
        <div className="apl-alert" role="status" data-testid="apl-attention">
            <span className="apl-alert__icon"><Warning size={20} aria-hidden="true"/></span>
            <div className="apl-alert__body">
                <p className="apl-alert__title">{t(`${NS}.attention_title`, {count: items.length})}</p>
                <ul className="apl-alert__list">
                    {items.map((item) => {
                        const key = `${item.channel}-${item.credential.id}`;
                        return (
                            <li key={key} className="apl-alert__item">
                                <span className="apl-alert__text">{attentionText(t, item, i18n && i18n.language)}</span>
                                {item.action === 'send_link' ? (
                                    onSendLink && (
                                        <button type="button" className="apl-btn -sm" data-testid="apl-attention-send-link"
                                                onClick={() => onSendLink(item.credential)}>
                                            {t('connections.mercado_ads.send_new_link')}
                                        </button>
                                    )
                                ) : (
                                    <button type="button" className="apl-btn -sm" onClick={reconnect(item)}
                                            disabled={busy === key} aria-busy={busy === key || undefined}>
                                        <ArrowsClockwise size={15} aria-hidden="true"/>
                                        {t(`${NS}.reconnect`)}
                                    </button>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}

export default AttentionNotice;
